import 'css-chunksrc/client/pages/projectPage/documentsPage/reportsPage/reportsList/styles.scss';export default {
  "reportsList": "_reportsList_1l1qw_1"
};